export default __webpack_public_path__ + "static/media/CompleteProfile.c59018a5.png";